export const ACCRELEASETRANS_LOADING = "ACCRELEASETRANS_LOADING";
export const GET_ACCRELEASETRANS_ONE = "GET_ACCRELEASETRANS_ONE";
export const ACCRELEASETRANS_RESET = "ACCRELEASETRANS_RESET";
export const GET_ACCRELEASETRANS = "GET_ACCRELEASETRANS";
export const GET_ACCRELEASETRANS_SUCCESS = "GET_ACCRELEASETRANS_SUCCESS";
export const GET_ACCRELEASETRANS_FAIL = "GET_ACCRELEASETRANS_FAIL";
export const DELETE_ACCRELEASETRANS = "DELETE_ACCRELEASETRANS"
export const DELETE_ACCRELEASETRANS_SUCCESS = "DELETE_ACCRELEASETRANS_SUCCESS"
export const DELETE_ACCRELEASETRANS_FAIL = "DELETE_ACCRELEASETRANS_FAIL"
export const UPDATE_ACCRELEASETRANS = "UPDATE_ACCRELEASETRANS"
export const UPDATE_ACCRELEASETRANS_SUCCESS = "UPDATE_ACCRELEASETRANS_SUCCESS"
export const UPDATE_ACCRELEASETRANS_FAIL = "UPDATE_ACCRELEASETRANS_FAIL"
export const ADD_NEW_ACCRELEASETRANS = "ADD_NEW_ACCRELEASETRANS"
export const ADD_ACCRELEASETRANS_SUCCESS = "ADD_ACCRELEASETRANS_SUCCESS"
export const ADD_ACCRELEASETRANS_FAIL = "ADD_ACCRELEASETRANS_FAIL"